import React from "react";
import { isMobile } from "react-device-detect";

const RegressionWidgetHeader = () => {
  return (
    <header className="widget-header--politics">
      <h2 className="politics__header">
        <div className="politics__title">
          <a href="https://www.news247.gr/pollitics/">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="127"
              height="32"
              viewBox="0 0 127 32"
            >
              <g
                id="Group_3907"
                data-name="Group 3907"
                transform="translate(262.099 -2424.874)"
              >
                <path
                  id="Path_2036"
                  data-name="Path 2036"
                  d="M-262.1,2426.817h7.843a9.072,9.072,0,0,1,5.969,1.733c1.462,1.244,2.285,3.222,2.285,6.16v5.506c0,3.08-.8,5.078-2.244,6.343s-3.5,1.754-5.97,1.754h-1.215v9.545h-6.67Zm7.76,15.113c1.256,0,1.647-.551,1.647-1.714v-5.506c0-.959-.391-1.448-1.564-1.448h-1.174v8.668Z"
                  transform="translate(0 -1.454)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2037"
                  data-name="Path 2037"
                  d="M-188.358,2454.569a8.951,8.951,0,0,1-1.791-6.016v-15.379a8.928,8.928,0,0,1,1.791-6c1.276-1.469,3.273-2.3,6.32-2.3s5.064.836,6.34,2.3a8.944,8.944,0,0,1,1.77,6.017v15.378a8.922,8.922,0,0,1-1.77,6c-1.276,1.469-3.294,2.3-6.34,2.3S-187.082,2456.037-188.358,2454.569Zm7.514-4.813a2.779,2.779,0,0,0,.247-1.183v-15.378a2.629,2.629,0,0,0-.247-1.2,1.274,1.274,0,0,0-1.194-.673c-.041,0-.062,0-.082-.021a1.229,1.229,0,0,0-1.112.694,2.778,2.778,0,0,0-.247,1.182v15.379a2.669,2.669,0,0,0,.268,1.2,1.2,1.2,0,0,0,1.173.673H-182c0,.02,0,.02.021.02A1.261,1.261,0,0,0-180.844,2449.755Z"
                  transform="translate(-53.675 0.001)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2038"
                  data-name="Path 2038"
                  d="M-116.376,2426.817h6.67v24.7h7.287v6.344h-13.957Z"
                  transform="translate(-108.709 -1.454)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2039"
                  data-name="Path 2039"
                  d="M-53.908,2426.817h6.67v24.7h7.287v6.344H-53.908Z"
                  transform="translate(-155.311 -1.454)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2040"
                  data-name="Path 2040"
                  d="M10.1,2426.978h2.367v31H10.1Z"
                  transform="translate(-203.062 -1.574)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2041"
                  data-name="Path 2041"
                  d="M36.222,2429.283H30.458v-2.223h13.9v2.223H38.589v28.757H36.222Z"
                  transform="translate(-218.247 -1.636)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2042"
                  data-name="Path 2042"
                  d="M96.34,2426.978h2.367v31H96.34Z"
                  transform="translate(-267.395 -1.574)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2043"
                  data-name="Path 2043"
                  d="M122.428,2455.888a6.431,6.431,0,0,1-1.873-3.528,20.01,20.01,0,0,1-.371-4.324V2435a19.4,19.4,0,0,1,.391-4.405,6.272,6.272,0,0,1,1.894-3.487,6.56,6.56,0,0,1,4.508-1.428H127a6.738,6.738,0,0,1,4.57,1.448,6.394,6.394,0,0,1,1.873,3.365,16.966,16.966,0,0,1,.371,3.9v.592h-2.388v-.592a10.417,10.417,0,0,0-.721-4.589,3.748,3.748,0,0,0-3.705-1.937,3.649,3.649,0,0,0-3.705,2.06,12.475,12.475,0,0,0-.741,5.119V2448a21.145,21.145,0,0,0,.227,3.548,4.571,4.571,0,0,0,1.214,2.59,4.113,4.113,0,0,0,3.006,1,3.769,3.769,0,0,0,3.643-1.876,10.012,10.012,0,0,0,.782-4.649v-.592h2.388v.613a15.993,15.993,0,0,1-.412,3.936,6.379,6.379,0,0,1-1.914,3.365,7.9,7.9,0,0,1-9.057-.041Z"
                  transform="translate(-285.183 -0.605)"
                  fill="#00023c"
                ></path>
                <path
                  id="Path_2044"
                  data-name="Path 2044"
                  d="M185.706,2455.011c-.947-1.448-1.132-3.467-1.132-5.772v-1.224H186.9v1.081c0,2.06.165,3.569.823,4.548.638,1,1.729,1.489,3.623,1.489a3.841,3.841,0,0,0,3.438-1.631,7.415,7.415,0,0,0,.947-4.08v-.223a7.165,7.165,0,0,0-.865-3.732,6.946,6.946,0,0,0-2.635-2.386l-3.026-1.734a8.746,8.746,0,0,1-3.4-3.141,9.463,9.463,0,0,1-1.029-4.854v-.367c0-4.589,2.264-7.3,6.649-7.3a6.189,6.189,0,0,1,5.084,2.081,8.426,8.426,0,0,1,1.544,5.384v1.836H195.69l-.041-2.468a5.436,5.436,0,0,0-1.029-3.283,3.923,3.923,0,0,0-3.211-1.366,3.785,3.785,0,0,0-3.376,1.652,6.471,6.471,0,0,0-.885,3.875l.021.734a6.311,6.311,0,0,0,3.561,5.282l2.985,1.673a8.579,8.579,0,0,1,3.294,3.222,10.215,10.215,0,0,1,1.112,4.65v.408a9.377,9.377,0,0,1-1.544,5.833,6.214,6.214,0,0,1-5.208,2.142C188.32,2457.336,186.653,2456.479,185.706,2455.011Z"
                  transform="translate(-333.218 -0.605)"
                  fill="#00023c"
                ></path>
              </g>
            </svg>
          </a>
        </div>
      </h2>
      <div>
        <span className="politics__text">
          Το ρεζουμέ των δημοσκοπήσεων για να ξέρεις κάθε στιγμή τις τάσεις στην
          Ελλάδα
        </span>
        {!isMobile && (
          <span>
            <a
              className="politics__button"
              href="https://www.news247.gr/pollitics"
              target="_self"
            >
              ΔΕΙΤΕ ΑΝΑΛΥΤΙΚΑ
            </a>
          </span>
        )}
      </div>
    </header>
  );
};

export default RegressionWidgetHeader;
